import dayjs from "dayjs";
import "dayjs/locale/fr";
import moment from "moment";
import "moment/locale/fr";
import { setDefaultOptions } from "date-fns";
import { fr } from "date-fns/locale";

// Valeurs communes aux calendriers et aux formats longs de toute l’application.
dayjs.locale("fr");
moment.locale("fr");
setDefaultOptions({ locale: fr, weekStartsOn: 1 });
